import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openLoginModal } from "../../../../redux/authSlice";
import api from "../../../utils/api";
import { useToast } from "../../../../context/ToastContext";
import { FaLock } from "react-icons/fa";

const FullPageGame = ({ gameId, pageTitle }) => {
    const { user } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const { showToast } = useToast();

    const [launchUrl, setLaunchUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const prevUserIdRef = useRef(user?._id || null);

    // Reset any previously launched session whenever the logged-in user
    // changes (login, logout, or switching accounts) so a stale iframe
    // from another user's session is never shown to the current user.
    useEffect(() => {
        const currentUserId = user?._id || null;
        if (prevUserIdRef.current !== currentUserId) {
            prevUserIdRef.current = currentUserId;
            setLaunchUrl(null);
            setError(null);
        }
    }, [user]);

    useEffect(() => {
        // If not logged in, or already launched/errored, stop here.
        if (!user || launchUrl || error) return;

        const launchGame = async () => {
            try {
                setLoading(true);
                setError(null);

                // Launch using the provided Game ID (MongoDB ID)
                const launchRes = await api.post("/games/launch", { gameId });

                if ((launchRes.data.status || launchRes.data.success) && launchRes.data?.data?.url) {
                    setLaunchUrl(launchRes.data.data.url);
                } else {
                    throw new Error(launchRes.data.message || "Failed to launch game");
                }
            } catch (err) {
                console.error("Game launch error:", err);
                setError(err.response?.data?.message || err.message || "Failed to launch game");
                showToast(err.response?.data?.message || "Failed to launch game", "danger");
            } finally {
                setLoading(false);
            }
        };

        launchGame();
    }, [user, gameId, showToast, launchUrl, error]);

    // Case 1: Not Logged In
    // if (!user) {
    //     return (
    //         <div style={{
    //             height: "100%",
    //             width: "100%",
    //             background: "#0b0b0f",
    //             display: "flex",
    //             flexDirection: "column",
    //             justifyContent: "center",
    //             alignItems: "center",
    //             color: "white"
    //         }}>
    //             <div style={{
    //                 background: "#1a1a1a",
    //                 padding: "40px",
    //                 borderRadius: "16px",
    //                 textAlign: "center",
    //                 boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
    //                 maxWidth: "400px",
    //                 width: "90%"
    //             }}>
    //                 <div style={{
    //                     width: "60px",
    //                     height: "60px",
    //                     background: "rgba(255, 153, 0, 0.1)",
    //                     borderRadius: "50%",
    //                     display: "flex",
    //                     alignItems: "center",
    //                     justifyContent: "center",
    //                     margin: "0 auto 20px"
    //                 }}>
    //                     <FaLock size={24} color="#ff9900" />
    //                 </div>
    //                 <h2 style={{ marginBottom: "10px", fontSize: "1.5rem" }}>Login Required</h2>
    //                 <p style={{ color: "#888", marginBottom: "25px" }}>
    //                     You need to be logged in to access {pageTitle || "this game"}.
    //                 </p>
    //                 <button
    //                     onClick={() => dispatch(openLoginModal())}
    //                     style={{
    //                         background: "linear-gradient(90deg, #ff9900 0%, #ff5e00 100%)",
    //                         color: "white",
    //                         border: "none",
    //                         padding: "12px 30px",
    //                         fontSize: "16px",
    //                         fontWeight: "600",
    //                         borderRadius: "8px",
    //                         cursor: "pointer",
    //                         width: "100%"
    //                     }}
    //                 >
    //                     Login Now
    //                 </button>
    //             </div>
    //         </div>
    //     );
    // }

    if (!user) {
        return (
            <div style={{ height: "100%", width: "100%", overflow: "hidden", background: "#000" }}>
                <iframe
                    src="https://exdemo.uni247.app"
                    title={pageTitle}
                    width="100%"
                    height="100%"
                    allowFullScreen
                    style={{ border: "none" }}
                />
            </div>
        );
    }

    // Case 2: Loading
    if (loading) {
        return (
            <div style={{
                height: "100%",
                width: "100%",
                background: "#0b0b0f",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "#ff9900",
                fontSize: "1.2rem",
                fontWeight: "600"
            }}>
                Loading Game...
            </div>
        );
    }

    // Case 3: Error
    if (error) {
        return (
            <div style={{
                height: "100%",
                width: "100%",
                background: "#0b0b0f",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "#ff4d4d",
                flexDirection: "column",
                gap: "15px"
            }}>
                <h2>Unable to Launch Game</h2>
                <p>{error}</p>
                <button
                    onClick={() => window.location.reload()}
                    style={{
                        background: "#333",
                        color: "white",
                        border: "none",
                        padding: "10px 20px",
                        borderRadius: "6px",
                        cursor: "pointer"
                    }}
                >
                    Retry
                </button>
            </div>
        );
    }

    // Case 4: Launch URL Ready
    if (launchUrl) {
        return (
            <div style={{ height: "100%", width: "100%", overflow: "hidden", background: "#000" }}>
                <iframe
                    src={launchUrl}
                    title={pageTitle}
                    width="100%"
                    height="100%"
                    allowFullScreen
                    style={{ border: "none" }}
                />
            </div>
        );
    }

    return null; // Should not trigger
};

export default FullPageGame;
